import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const BEAR = "bear";
const BUFFALO = "buffalo";
const CHICK = "chick";
const CHICKEN = "chicken";
const COW = "cow";
const CROCODILE = "crocodile";
const DOG = "dog";
const DUCK = "duck";
const ELEPHANT = "elephant";
const FROG = "frog";
const GIRAFFE = "giraffe";
const GOAT = "goat";
const GORILLA = "gorilla";
const HIPPO = "hippo";
const HORSE = "horse";
const MONKEY = "monkey";
const MOOSE = "moose";
const NARWHAL = "narwhal";
const OWL = "owl";
const PANDA = "panda";
const PARROT = "parrot";
const PENGUIN = "penguin";
const PIG = "pig";
const RABBIT = "rabbit";
const RHINO = "rhino";
const SLOTH = "sloth";
const SNAKE = "snake";
const WALRUS = "walrus";
const WHALE = "whale";
const ZEBRA = "zebra";

const ANIMAL_COLLECTION = [
  BEAR,
  BUFFALO,
  CHICK,
  CHICKEN,
  COW,
  CROCODILE,
  DOG,
  DUCK,
  ELEPHANT,
  FROG,
  GIRAFFE,
  GOAT,
  GORILLA,
  HIPPO,
  HORSE,
  MONKEY,
  MOOSE,
  NARWHAL,
  OWL,
  PANDA,
  PARROT,
  PENGUIN,
  PIG,
  RABBIT,
  RHINO,
  SLOTH,
  SNAKE,
  WALRUS,
  WHALE,
  ZEBRA
];

const BOARD_SIZE = 36;

const makeNewBoard = () => {
  const stack = [];
  const board = Array.from(Array(BOARD_SIZE)).map(() => null);

  for (let i = 0; i < BOARD_SIZE / 2; i++) {
    let card = null;
    while (card === null || stack.indexOf(card) >= 0) {
      card =
        ANIMAL_COLLECTION[Math.floor(Math.random() * ANIMAL_COLLECTION.length)];
    }
    stack.push(card);
    stack.push(card);
  }

  while (stack.length) {
    const card = stack.pop();
    let index = null;
    while (index === null || board[index] !== null) {
      index = Math.floor(Math.random() * BOARD_SIZE);
    }
    board[index] = card;
  }

  return board;
};

const state = {
  cards: makeNewBoard(),
  uncovered: [],
  tries: []
};

const getters = {
  cards: state => state.cards,
  isCovered: state => index =>
    !state.uncovered.includes(index) && !state.tries.includes(index),
  tries: state => state.tries,
  triesMatch: state =>
    state.tries.length === 2 &&
    state.cards[state.tries[0]] === state.cards[state.tries[1]],
  gameOver: state => state.uncovered.length === BOARD_SIZE
};

const mutations = {
  addTry(state, index) {
    state.tries.push(index);
  },
  clearTries(state) {
    state.tries = [];
  },
  uncoverTries(state) {
    state.uncovered = state.uncovered.concat(state.tries);
  },
  coverAll(state) {
    state.uncovered = [];
  },
  makeNewBoard(state) {
    state.cards = makeNewBoard();
  }
};

const actions = {
  tryCard({ commit, getters }, index) {
    if (getters.isCovered(index) && getters.tries.length < 2) {
      commit("addTry", index);
      if (getters.tries.length > 1) {
        if (getters.triesMatch) {
          commit("uncoverTries");
        }
        setTimeout(() => commit("clearTries"), 1000);
      }
    }
  },
  startOver({ commit }) {
    commit("makeNewBoard");
    commit("clearTries");
    commit("coverAll");
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});
